import React,{ Component, Fragment } from 'react'
import './DocumentacionNuevo.css';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import MyButton from '../../../utils/MyButton';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { useDropzone } from 'react-dropzone';
import {  FaArrowLeft, FaPlus, FaFileImport, FaCheck, FaCheckCircle, FaFileUpload } from "react-icons/fa";

import { postDocLegal, clearErrors, getDocsLegal } from '../../../redux/actions/dataactions';
import IconButton from '@mui/material/IconButton';
import { Tooltip, Typography } from '@mui/material';

// Crear un componente funcional para usar el hook useDropzone
const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1,
    onDrop: onFileDrop
  });

  return (
    <div className="dropzone-container mt-4">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p className="dropzone-text">Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo</p>
        <em className="dropzone-info">(Solo se permite subir un archivo PDF, DOC o DOCX)</em>
      </div>
      
      <aside className="dropzone-preview">
        {fileRejections.length > 0 && (
          <div className="file-error">
            <h4>Solo se puede cargar un archivo</h4>
          </div>
        )}

        {acceptedFiles.length > 0 && (
          <div className="file-accepted">
            <h4>Archivo a cargar:</h4>
            <ul className="file-list">
              {acceptedFiles.map(file => (
                <li key={file.path} className="file-item">
                  {file.path} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

export class DocumentacionNuevo extends Component {
    constructor() {
        super();
        this.state = {
            tipodoc: '',
            descripcion: '',
            consecutivo: '',
            documento: null,
            errors: {},
            aprobado:{},
            open: false
        };
    };

    static getDerivedStateFromProps(props, state) {
      const newState = {};
    
      if (props.UI.errors) {
        newState.errors = props.UI.errors;
      }
    
      if (props.UI.aprobado) {
        newState.aprobado = props.UI.aprobado;
      }
    
      return Object.keys(newState).length > 0 ? newState : null;
  }
    handleOpen = () => {
      this.setState({
        open: true,
        tipodoc: '',
        descripcion: '',
        consecutivo: '',
        aprobado:'',
        documento: null,
        errors: {}
    });
    };
    
    
     handleClose = () => {
      this.props.clearErrors();
            if (this.state.aprobado && this.state.aprobado.mensaje) {
                console.log(this.state.aprobado);
                
                this.setState({
                  open: false,
                  tipodoc: '',
                  descripcion: '',
                  consecutivo: '',
                  aprobado:'',
                  documento: null,
                  errors: {}
              });
                // Recargar la lista de solicitudes
                this.props.getDocsLegal(this.props.clienteId);
            } else {
              this.setState({
                open: false,
                tipodoc: '',
                descripcion: '',
                consecutivo: '',
                aprobado:{},
                documento: null,
                errors: {}
            });
            }
        };

    

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleFileDrop = (acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            this.setState({ documento: acceptedFiles[0] });
        }
    };

    handleSubmit = (event) => {
        event.preventDefault();
        
        const formData = new FormData();
        formData.append('tipodoc', this.state.tipodoc);
        formData.append('descripcion', this.state.descripcion);
        formData.append('consecutivo', this.state.consecutivo);
        formData.append('clienteid', this.props.clienteId);
        
        if (this.state.documento) {
            formData.append('documento', this.state.documento);
        } else {
            formData.append('url', 'Sin Url');
        }

        console.log('Enviando datos:', {
            tipodoc: this.state.tipodoc,
            descripcion: this.state.descripcion,
            consecutivo: this.state.consecutivo,
            clienteid: this.props.clienteId,
            documento: this.state.documento ? 'Archivo adjunto' : 'Sin documento'
        });
        
        this.props.postDocLegal(formData, this.props.clienteId);
    };

    render() {
        const { UI: { loading, aprobado } } = this.props;
        const { errors } = this.state;

        return (
            <Fragment>
                <Tooltip title="Nuevo Documento">
                <IconButton onClick={this.handleOpen}>
                    <FaFileUpload color="#03178C" className="icon-crearcliente" />
                </IconButton>
                </Tooltip>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle><Typography sx={{ 
                                  fontSize: '20px', 
                                  fontWeight: 400, 
                                  color: '#0468BF', 
                                  textAlign: 'start' 
                                  }}>
                                  Agregar Nuevo Documento
                  </Typography></DialogTitle>

                    {this.state.aprobado && this.state.aprobado.mensaje ? (
                        <DialogContent>
                            <div className='div-aprobado'>
                                <div className='div-icono-aprobado'>
                                    <FaCheck color="#ffffff" className='icono-aprobado' />
                                </div>
                                <h2 className='text-aprobado'>¡Documento Creado Exitosamente!</h2>
                            </div>
                        </DialogContent>
                    ) : (
                        <DialogContent>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} mt={2}>
            <FormControl fullWidth error={!!errors.tipodoc}>
              <InputLabel id="tipodoc-label">Tipo Documento</InputLabel>
              <Select
                labelId="tipodoc-label"
                name="tipodoc"
                value={this.state.tipodoc}
                onChange={this.handleChange}
                label="Tipo Documento"
              >
                <MenuItem value=""><em>Seleccione</em></MenuItem>
                <MenuItem value="Contrato">Contrato</MenuItem>
                <MenuItem value="Factura">Factura</MenuItem>
                <MenuItem value="Hoja de Vida">Hoja de Vida Ingeniero</MenuItem>
                <MenuItem value="Registro Invima">Registro Invima</MenuItem>
                <MenuItem value="Programa de Tecnovigilancia">Programa de Tecnovigilancia</MenuItem>
                <MenuItem value="Programa de Capacitaciones">Programa de Capacitaciones</MenuItem>
                <MenuItem value="Programa de Mantenimiento">Programa de Mantenimiento</MenuItem>
                <MenuItem value="Certificado de Patron">Certificado de Patron</MenuItem>
                <MenuItem value="Capacitacion">Capacitacion</MenuItem>
                <MenuItem value="Protocolo de Tecnologia">Protocolo de Tecnologia</MenuItem>
                <MenuItem value="Programa Metrologico">Programa Metrologico</MenuItem>
                <MenuItem value="Capacidad Instalada">Capacidad Instalada</MenuItem>
                <MenuItem value="Proceso de Gestion del Riesgo">Proceso de Gestión del Riesgo</MenuItem>
              </Select>
              <FormHelperText>{errors.tipodoc}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              name="descripcion"
              label="Descripción"
              value={this.state.descripcion}
              onChange={this.handleChange}
              helperText={errors.descripcion}
              error={!!errors.descripcion}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              name="consecutivo"
              label="Consecutivo"
              value={this.state.consecutivo}
              onChange={this.handleChange}
              helperText={errors.consecutivo}
              error={!!errors.consecutivo}
            />
          </Grid>

          <Grid item xs={12}>
            <FileDropzone onFileDrop={this.handleFileDrop} />
          </Grid>

          <Grid item xs={12}>
            <div className="error-container">
              {errors?.errors?.length > 0 && (
                <ul className="error-list">
                  {errors.errors.map((error, i) => <li key={i}>{error}</li>)}
                </ul>
              )}
            </div>
          </Grid>
        </Grid>
      </form>
    </DialogContent>
                    )}

                    <DialogActions>
    <Tooltip title="Cerrar">
      <IconButton onClick={this.handleClose}>
        <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
      </IconButton>
    </Tooltip>

    {loading ? (
      <CircularProgress size={30} color="primary" />
    ) : this.state.aprobado?.mensaje ? (
      <Tooltip title="Continuar">
        <IconButton onClick={this.handleClose}>
          <FaCheckCircle color="#20B90C" className="icon-formulario" />
        </IconButton>
      </Tooltip>
    ) : (
      <Tooltip title="Guardar Documento">
        <span>
          <IconButton
            onClick={this.handleSubmit}
            disabled={!this.state.tipodoc || !this.state.descripcion || !this.state.consecutivo}
          >
            <FaPlus color="#03178C" className="icon-formulario" />
          </IconButton>
        </span>
      </Tooltip>
    )}
  </DialogActions>
                </Dialog>
            </Fragment>
        )
    }
}

DocumentacionNuevo.propTypes = {
  postDocLegal: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  getDocsLegal: PropTypes.func.isRequired,  // Añadido getDocsLegal
  UI: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  UI: state.UI
});

export default connect(mapStateToProps, { postDocLegal, clearErrors, getDocsLegal })(DocumentacionNuevo);